import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenAppSignOrder } from '../models/open-app/open-app-sign-order.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmOpenAppSignOrderService extends RequestService<OpenAppSignOrder> {
  static PATH = '/om/open/app/signorder';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmOpenAppSignOrderService.PATH, globalService.debugUrl);
  }
}
